import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

export const PageFilterWatcher = (): null => {
  const validFilterPaths = [
    '/financial/event-close',
    '/financial/producer',
    '/financial/event/producer-report/',
  ];
  const location = useLocation();

  const cliearSessionStorage = (): void => {
    const isValid = validFilterPaths.some(path => location.pathname.startsWith(path));
    if (!isValid) {
      sessionStorage.removeItem('/event-close-page');
      sessionStorage.removeItem('/financial-page');
    }
  };

  useEffect(() => {
    cliearSessionStorage();
  }, [location.pathname]);

  return null;
};
